import { render, staticRenderFns } from "./AuthentForm.vue?vue&type=template&id=6e645aa1&scoped=true"
import script from "./AuthentForm.vue?vue&type=script&lang=js"
export * from "./AuthentForm.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/user-info.css?vue&type=style&index=0&id=6e645aa1&prod&scoped=true&lang=css&external"
import style1 from "./AuthentForm.vue?vue&type=style&index=1&id=6e645aa1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e645aa1",
  null
  
)

export default component.exports